<template>
  <div class="dict-create-select" :class="{ 'is-disabled': disabled }">
    <el-input v-model="value" readonly :disabled="disabled">
      <el-button
        slot="append"
        icon="el-icon-more"
        @click="operation"
      ></el-button>
    </el-input>

    <ChooseSysUser
      :visible.sync="visible"
      width="1000px"
      confirmOnClose
      multiple
      @confirm="onConfirm"
      :extraData="{}"
    ></ChooseSysUser>
  </div>
</template>

<script>
import ChooseSysUser from './choose-user-dialog'
export default {
  components: {
    ChooseSysUser,
  },
  props: {
    value: {},
    placeholder: { type: String, default: '请选择' },
    size: { type: String, default: '' },
    clearable: { type: Boolean, default: false },
    disabled: { type: Boolean, default: true },
    multiple: { type: Boolean, default: false },
    body: Object,
    url: { type: String, default: '/master/common/dict/baseUserSelect' },
    cache: { type: Boolean, default: false },
    separator: { type: String, default: '、' },
  },
  data() {
    return {
      visible: false,
    }
  },
  computed: {},
  methods: {
    operation() {
      this.visible = true
    },
    async onConfirm(data) {
      this.$emit('confirm', data)
    },
  },
}
</script>

<style lang="scss" scoped>
.dict-create-select {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: stretch;

  ::v-deep {
    .dict-select {
      flex-grow: 1;
      .el-input__inner {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
    }
  }

  .dict-create-select_append {
    width: 50px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    border: #909399;
    border-left: 0;
    border-radius: 4px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    background-color: #f5f7fa;
  }
}

.dict-create-select.is-disabled {
  .dict-create-select_append {
    cursor: not-allowed;
  }
}

.el-form-item.is-error {
  .dict-create-select_append {
    border-color: var(--el-color-danger);
  }
}
</style>
